import AdminModalEdit from '../Components/SiteAdmin/SiteAdminModalEdit';
import AdminModalCreate from '../Components/SiteAdmin/SiteAdminModalCreate';
import Preview from "../Components/Preview/Preview";
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import baseUrlApi from '../lib/baseUrlApi';
import { useForm, SubmitHandler } from 'react-hook-form';
import HEADER from "../Components/header";
import BACK from '../images/icon-back-b.svg';
import { useCookies } from 'react-cookie';
import { Link, useNavigate } from 'react-router-dom';
import {ApiRequest} from "../Consts/ApiRequest";
import MessageComponent from "../Components/MessageComponent";
// import { Console, log } from 'console';

type Site = {
  gateways: [{
      contactEnd: string,
      controlId: string,
      gatewayId: string,
      gatewayRecno: number
  }],
  siteId: string,
  siteName: string,
  siteRecno:string,
  memo:string,
};

type SiteAdminInputs = {
  gatewayCount: string,
  siteId: string,
  siteName: string,
  memo: string,
  sitePass: {
    admin: string,
    user: string,
  },
  siteRecno: number,
  gateways: [
    {
      contactEnd: string,
      controlId: string,
      gatewayId: string,
      gatewayRecno: number,
    }
  ]
};

const SiteAdmin = (props: any) => {
  const navigate = useNavigate();
  const [siteAdminData, setSiteAdminData] = useState<SiteAdminInputs[]>([]);
  const [sites, setSites] = useState<Site[]>([]);
  const [siteId, setSiteId] = useState<string>("");
  const [gatewayCount, setGatewayCount] = useState<string>("");
  const [siteRecno, setSiteRecno] = useState<number>(0);
  const [state, setState] = useState("")
  const { register, handleSubmit, formState: { errors } } = useForm<SiteAdminInputs>();
  const [cookies, setCookie, removeCookie] = useCookies(['authority', 'access_token', "siteId", "siteRecno"]);

  let defaultParams:any = {
    "siteRecno": "",
    "siteId": "",
    "prcKind": 0,
    "sitePass": {
      "admin": "",
      "user": "",
    },
    "gatewayCount": 0,
    "memo": ""
  }

  const changeState = (isState: string) => {
    setState(isState)
    getSite();
  }

  function errorCallback(error:any){
    if (error.response && error.response.status === 401) {
      console.error("Error token error:", error);
      removeCookie('access_token', {path: '/'});
      removeCookie('authority', {path: '/'});
      removeCookie('siteId', {path: '/'});
      removeCookie('siteRecno', {path: '/'});
      navigate("logout");
    }
    console.error("Error fetching dataSite:", error);
  }

  useEffect(() => {
    if(cookies.authority == 1 || cookies.authority == 3 || cookies.authority == 4) {
      removeCookie('access_token', {path: '/'});
      removeCookie('authority', {path: '/'});
      removeCookie('siteId', {path: '/'});
      removeCookie('siteRecno', {path: '/'});
      navigate("logout");
  }
    getSite();
    getSiteList();
  }, []);

  const getSite = async () => {
    const token = cookies.access_token || "";
    ApiRequest.getSiteManage(defaultParams, token, (response: any) => {
      setSiteAdminData(response.data.sites);
      console.log(response.data.sites);
    }, (error:any)=>{
      errorCallback(error);
    })
  };

  const getGateways = (siteId:string) => {
    var x =  sites.filter((e, index)=>{
      return e.siteId === siteId;
    })[0]?.gateways || [];
    console.log("...");
    console.log(x);
    return x;
  }

  const getSiteList = async () => {
    let params = {
      prcKind: 1,
      siteId: siteId,
      siteRecno: siteRecno,
    };
    const token = cookies.access_token || "";
    ApiRequest.getSite(params, token, (response: any) => {
      setSites(response.data.sites);
      console.log(response.data.sites);
    }, (error:any)=>{
      errorCallback(error);
    });
  };

  const onSubmit: SubmitHandler<SiteAdminInputs> = async (data) => {
    try {
      let param = defaultParams;
      param.prcKind = 1;
      param.siteId = siteId;
      setSiteAdminData([]);

      if(!gatewayCount){
        delete param.gatewayCount;
      }else{
        param.gatewayCount = Number(gatewayCount);
      }
      const token = cookies.access_token || "";
      ApiRequest.getSiteManage(param, token,
          (response:any)=> {
            if (Array.isArray(response.data.sites)) {
              setSiteAdminData(response.data.sites);
            }
      },(error:any)=>{
        errorCallback(error);
      })
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  return (
    <>
      <div className="wrapper">
        {
          cookies.authority == 2 ?
            <HEADER TopPage="/site_admin" />
              :
            <HEADER TopPage="/" />
        }

        <main className="main">
          <section className="page-head" id="page-head">
            <div className="page-head-block">
              <div className="page-name">
                {
                  cookies.authority !== 2 ? <a onClick={() => navigate(-1)}>
                    <img src="https://www.sooki-cloud-portalsystem.jp/static/media/icon-back-b.a302f48a196965a4ff8d4568031a609b.svg" alt="戻る" />
                  </a> : <></>
                }
                <div className="page-name-label">現場管理画面</div>
              </div>
              <div className="page-option">
                <AdminModalCreate
                  setState={changeState}
                />
              </div>
            </div>
          </section>
          <section className="page-body scroll-block">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="search-box">
                <div className="search-box-elm">
                  <div className="search-box-elm-name">現場ID</div>
                  <div className="search-box-elm-input">
                    <input
                      type="text"
                      value={siteId}
                      placeholder="siteId"
                      {...register("siteId")
                      }
                      className="col-320"
                      onChange={e => setSiteId(e.target.value)}
                    />
                    {errors.siteId && <p className="error-msg">{errors.siteId.message}</p>}
                  </div>
                </div>
                <div className="search-box-elm">
                  <div className="search-box-elm-name">Gateway登録数</div>
                  <div className="search-box-elm-input">
                    <input
                      type="text"
                      value={gatewayCount}
                      placeholder="gatewayCount"
                      {...register("gatewayCount")
                      }
                      className=""
                      onChange={e => setGatewayCount(e.target.value)}
                    />
                    {errors.gatewayCount && <p className="error-msg">{errors.gatewayCount.message}</p>}
                  </div>
                </div>
                <div className="search-box-btn">
                  <button className="btn btn-white-line">
                    <i className="icon-search-w"></i>検索</button>
                </div>
              </div>
            </form>

            <div className="table-box">
              <table className="st-table">
                <thead>
                  <tr>
                    <th className="">現場ID</th>
                    <th className="">管理パスワード</th>
                    <th className="">閲覧パスワード</th>
                    <th className="">Gateway登録数</th>
                    <th className="">メモ</th>
                    <th className="col-200">データダウンロード</th>
                    <th className="col-100">印刷</th>
                    <th className="col-100">編集</th>
                  </tr>
                </thead>
                <tbody>
                  {siteAdminData.map((site, index) => (
                    <tr key={index}>
                      <td className="nowrap">
                        <Link to={`/gateway_sensor/${site?.siteId}/${site?.siteRecno}`}
                          className="list-link">
                          {site.siteId}
                        </Link>
                      </td>
                      <td className="nowrap">{site.sitePass.admin || "N/A"}</td>
                      <td className="nowrap">{site.sitePass?.user || "N/A"}</td>
                      <td className="nowrap">{site.gatewayCount}</td>
                      <td className="nowrap">
                        <MessageComponent message={site.memo || "-"} maxLength={8}/>
                      </td>
                      <td className="">
                        <button className="btn btn-blue-line">
                          <i className="icon-download-b">
                          </i>
                          <Link to={`/download/${site.siteId}/${site.siteRecno}`}>データダウンロード</Link>
                        </button>
                      </td>
                      <td className="">
                        <Preview adminPassword={site.sitePass?.admin} userPassword={site.sitePass?.user}
                                 siteId={site.siteId} gateways={getGateways(site.siteId)} />
                      </td>
                      <td className="">
                        <AdminModalEdit
                            admin={site.sitePass?.admin }
                            user={site.sitePass?.user}
                            siteId={site.siteId}
                            memo={site.memo}
                            siteRecno={site.siteRecno}
                            setState={changeState}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>
        </main>
      </div>
    </>
  )
};

export default SiteAdmin;
